export const API_TABS = {
    SETUP: {
        name: 'setup',
        caption: 'Setup',
    },
    PRICING: {
        name: 'pricing',
        caption: 'Pricing',
    },
    ALERTS: {
        name: 'alerts',
        caption: 'Alerts',
    },
    LIMITS: {
        name: 'limits',
        caption: 'Usage Limits',
    },
    CALLS: {
        name: 'calls',
        caption: 'Calls',
    },
    RELEASE_NOTES: {
        name: 'release-notes',
        caption: 'Release Notes',
    },
};
